<h2>{{ "CROP_IMAGE.TITLE" | translate }}</h2>
<div style="max-height: 70vh; overflow: auto; width: 100%">
  <image-cropper
    [imageChangedEvent]="data.imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="4 / 3"
    [resizeToWidth]="600"
    format="png"
    [cropperMinWidth]="100"
    [cropperMinHeight]="100"
    (imageCropped)="imageCropped($event)"
  >
  </image-cropper>
</div>

<div class="cropper-actions">
  <button mat-stroked-button color="warn" (click)="onCancel()">
    {{ "CROP_IMAGE.CANCEL" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onSave()">
    {{ "CROP_IMAGE.APPLY" | translate }}
  </button>
</div>